import { render, staticRenderFns } from "./ClientsDisplay.vue?vue&type=template&id=db631120&scoped=true&"
import script from "./ClientsDisplay.vue?vue&type=script&lang=js&"
export * from "./ClientsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ClientsDisplay.vue?vue&type=style&index=0&id=db631120&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db631120",
  null
  
)

export default component.exports